const TOS = () => {
    return (<div>Terms of Service coming soon...</div>)
}

export default TOS;